export default "__VITE_ASSET__B0wBSBc3__"